/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_InviteInputs */

const cs_client_portal_invite = /** @type {(inputs: Client_Portal_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat pozvánku`)
};

const en_client_portal_invite = /** @type {(inputs: Client_Portal_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send invite`)
};

/**
* | output |
* | --- |
* | "Send invite" |
*
* @param {Client_Portal_InviteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_invite = /** @type {((inputs?: Client_Portal_InviteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_InviteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_invite(inputs)
	return cs_client_portal_invite(inputs)
});